/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Price/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Price({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/Price",
  onChange,
  isInvalid
  
}) {
let chargePriceValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'price',
})
let chargePriceIsValidData = fromData.useDataIsValid({ viewPath,
context: 'charge',
path: 'price',
validate: fromValidate.numberZeroOrPositive,
})
let chargePriceChangeData = fromData.useDataChange({ viewPath,
context: 'charge',
path: 'price',
})
  return (<React.Fragment
>
<div
  data-testid="Price.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="charge.price"
 value={chargePriceValueData}
 onChange={chargePriceChangeData}
 validate="/Data/validate.js numberZeroOrPositive"
 invalid={!chargePriceIsValidData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Price"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}